<template>
  <v-dialog v-model="dialog" max-width="650" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Penilaian Kepala Sekolah</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <v-alert text dense color="info" class="mb-0">
          <v-row class="black--text">
            <v-col class="my-1" cols="12" md="6">
              <v-list-item class="px-0">
                <v-list-item-avatar color="secondary">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <div>
                    <span class="info--text mb-0" style="font-size: 17px">
                      {{ $getDeepObj(kasek, 'ptk_kasek.nama') || '-' }}
                    </span>
                    <div class="mt-1 mb-0">
                      <strong>No UKG:</strong> {{ $getDeepObj(kasek, 'ptk_kasek.no_ukg') || '-' }}
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="my-1" cols="12" md="6">
              <div>
                <span class="caption grey--text">Informasi Sekolah</span>
              </div>
              <div class="mb-0" style="font-size: 17px">
                {{ getInfoSekolah(kasek, 'nama') }}
              </div>
              <div> <strong>Alamat:</strong> {{ getInfoSekolah(kasek, 'alamat') }} </div>
            </v-col>
          </v-row>
        </v-alert>
        <div class="mt-5">
          <h3 class="black--text">
            Kriteria Penilaian Pusat <small class="grey--text font-weight-regular">(Tidak bisa diubah)</small>
          </h3>
          <v-divider class="blue my-1" />
          <v-row>
            <v-col v-for="(nilai, i) in nilaiPusat" cols="12" sm="12" md="6" :key="i">
              <div class="mb-1">
                <span class="px-0 body-2 black--text" style="height: 24px">
                  {{ i + 1 }}. {{ nilai.judul }} <span class="blue--text">({{ nilai.persen }}%)</span>
                </span>
              </div>
              <div class="grey lighten-3">
                <span class="black--text subtitle-1 ma-2">{{ nilai.nilai }}</span>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-5">
          <h3 class="black--text">
            Kriteria Penilaian Daerah
            <small class="orange--text text--darken-1 font-weight-regular">
              (Rentang Nilai antara {{ batasNilai.min }} - {{ batasNilai.max }})
            </small>
          </h3>
          <v-divider class="blue my-1" />
          <v-row>
            <v-col v-for="(nilai, i) in nilaiDaerah" cols="12" sm="12" md="6" :key="i">
              <div>
                <span class="px-0 body-2 black--text" style="height: 24px">
                  {{ i + 3 }}. {{ nilai.judul }} <span class="blue--text">({{ nilai.persen }}%)</span>
                </span>
              </div>
              <div class="mt-1">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="form[`kriteria_dinas_nilai_${i + 1}`]"
                  v-mask="'###'"
                />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text @click="close">
          Batal
        </v-btn>
        <v-btn class="ma-2" color="primary" elevation="1" @click="save">
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PopupNilai',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    kasek: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dialog: false,
      form: {},
    };
  },

  computed: {
    ...mapState('preferensi', {
      configPreferensi: (state) => state.data?.config ?? {},
    }),

    batasNilai() {
      const nilaiMin = Number(this.$getDeepObj(this.detail, 'konfigurasi.nilai_min')) || 0;
      const rentang = Number(this.$getDeepObj(this.configPreferensi, 'peringkat.rentang_nilai_dinas') || 0);

      return {
        min: nilaiMin,
        max: nilaiMin + rentang,
      };
    },

    nilaiPusat() {
      return [
        { judul: 'Wawancara Panel', persen: this.detail.persen_ww, nilai: this.kasek.nilai_ww },
        { judul: 'Simulasi Mengajar', persen: this.detail.persen_sm, nilai: this.kasek.nilai_sm },
      ];
    },

    nilaiDaerah() {
      let result = [];

      for (let i = 1; i <= 3; i++) {
        if (this.detail[`kriteria_dinas_persen_${i}`]) {
          result.push({
            judul: this.detail[`kriteria_dinas_nama_${i}`],
            persen: this.detail[`kriteria_dinas_persen_${i}`],
          });
        }
      }

      return result;
    },
  },

  methods: {
    getInfoSekolah(data, key) {
      const isSesuai = Number(data.is_sesuai) === 1;
      const sekolahAwal = this.$getDeepObj(data, 'ptk_kasek.ptk_tugases.0.sekolah') || {};
      const sekolahVerval = this.$getDeepObj(data, 'sekolah') || {};

      if (isSesuai) {
        return sekolahVerval[key] || '-';
      }

      return sekolahAwal[key] || '-';
    },

    getNilai() {
      return [
        Object.assign(
          {},
          { psp_peringkat_kandidat_id: this.$getDeepObj(this.kasek, 'psp_peringkat_kandidat_id') },
          this.form
        ),
      ];
    },

    open() {
      this.dialog = true;
      this.form = {};

      for (let i = 1; i <= 3; i++) {
        if (this.kasek[`kriteria_dinas_nilai_${i}`]) {
          this.$set(this.form, `kriteria_dinas_nilai_${i}`, this.kasek[`kriteria_dinas_nilai_${i}`]);
        }
      }
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.$emit('save', this.form);
    },
  },
};
</script>
